import React, { useState } from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import ChangeConsentModal from "../Common/popUpModals/ChangeConsentModal";

const PatientDetails = ({ pateintName, email, DOB, passStatus, sex, phoneNumber, state }) => {
  const [showConsentModal, setShowConsentModal] = useState(false);
  return (
    <>
      <ChangeConsentModal
        showConsentModal={showConsentModal}
        closeConsentModal={() => {
          setShowConsentModal(false);
        }}
        toggleConsent={() => {
          setShowConsentModal(false);
        }}
      />
      <Row align="start">
        <Col>
          <Form.Group className="FormCol" as={Row} controlId="patientDetailsFormId">
            <Form.Label id="cardFormLabel" column sm={4}>
              Patient Name
            </Form.Label>
            <Col sm={8}>
              <Form.Control
                placeholder="Patient name"
                aria-label="Patient name"
                aria-describedby="basic-addon1"
                defaultValue={pateintName}
                readOnly
              />
            </Col>
          </Form.Group>

          <Form.Group className="FormCol" as={Row} controlId="patientDetailsFormId">
            <Form.Label id="cardFormLabel" column sm={4}>
              Email
            </Form.Label>
            <Col sm={8}>
              <Form.Control placeholder="email" aria-label="email" aria-describedby="basic-addon1" defaultValue={email} readOnly />
            </Col>
          </Form.Group>

          <Form.Group className="FormCol" as={Row} controlId="patientDetailsFormId">
            <Form.Label id="cardFormLabel" column sm={4}>
              DOB
            </Form.Label>
            <Col sm={8}>
              <Form.Control placeholder="DOB" aria-label="DOB" aria-describedby="basic-addon1" defaultValue={DOB} readOnly />
            </Col>
          </Form.Group>
        </Col>

        <Col>
          <Form.Group className="FormCol" as={Row} controlId="patientDetailsFormId">
            <Form.Label id="cardFormLabel" column sm={4}>
              Patient Sex
            </Form.Label>
            <Col sm={8}>
              <Form.Control placeholder="sex" aria-label="sex" aria-describedby="basic-addon1" defaultValue={sex} readOnly />
            </Col>
          </Form.Group>

          <Form.Group className="FormCol" as={Row} controlId="patientDetailsFormId">
            <Form.Label id="cardFormLabel" column sm={4}>
              Phone No.
            </Form.Label>
            <Col sm={8}>
              <Form.Control placeholder="phoneNumber" aria-label="phoneNumber" aria-describedby="basic-addon1" defaultValue={phoneNumber} readOnly />
            </Col>
          </Form.Group>

          <Form.Group className="FormCol" as={Row} controlId="patientDetailsFormId">
            <Form.Label id="cardFormLabel" column sm={4}>
              Patient State
            </Form.Label>
            <Col sm={8}>
              <Form.Control placeholder="state" aria-label="state" aria-describedby="basic-addon1" defaultValue={state} readOnly />
            </Col>
          </Form.Group>
        </Col>
      </Row>
      <Row align="start">
        <Col sm={6}>
          <Form.Group className="FormCol" as={Row} controlId="patientDetailsFormId">
            <Form.Label id="cardFormLabel" column sm={4}>
              PASS Status
            </Form.Label>
            <Col sm={8}>
              <Form.Control
                placeholder="passStatus"
                aria-label="passStatus"
                aria-describedby="basic-addon1"
                defaultValue={passStatus ? "Consent Provided" : "Not given consent"}
                readOnly
              />
            </Col>
          </Form.Group>
        </Col>
        <Button
          variant="link"
          className="rounded-sm"
          size="sm"
          onClick={() => {
            setShowConsentModal(true);
          }}
        >
          Change Consent Status
        </Button>
      </Row>
    </>
  );
};

export default PatientDetails;
